import Joi from 'joi';

export const uscgServiceSchema = Joi.object({
  expiration_date: Joi.string().required(),
  title: Joi.string().required(),
  additional_information: Joi.string().required()
}).options({
  abortEarly: false
});
